<template>
  <div class="piece-tile">
    <div class="thumb-container">
      <img class="thumb" v-bind:src="imgPrefix + piece.url">
      <span class="thumb-hover icon-zoom-in"></span>
    </div>
    <div class="piece-data">
      <div class="piece-label">{{ piece.label }}</div>
      <div class="piece-size">{{ piece.size }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['piece', 'imgPrefix'],
};
</script>

<style lang="scss" scoped>
.thumb {
  height: 15rem;
}
.piece-tile {
  display: flex;
  flex-direction: column;
  padding: 1em;
  background: $card-border;
  box-shadow: 4px 4px 4px #aaa;
  margin: 1em;
  transition: 0.25s;
  cursor: pointer;
  img {
    margin-bottom: 1em;
  }
  &:hover {
    box-shadow: 6px 6px 4px #aaa;
  }
}
.thumb-container {
  position: relative;
  .thumb-hover {
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    color: white;
    font-size: 1.5rem;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.5);
    padding: 0.5em;
    border-radius: 5px;
    display: none;
    cursor: pointer;
  }
  &:hover {
    .thumb-hover {
      display: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Piece.vue?a040bbac